import {Routes} from '@angular/router';
import {LoginComponent} from "./pages/login/login.component";
import {SignupComponent} from "./pages/signup/signup.component";
import {ForgotPasswordComponent} from "./pages/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./pages/reset-password/reset-password.component";
import {VerifyEmailErrorComponent} from "./pages/verify-email-error/verify-email-error.component";
import {AuthorizationErrorComponent} from "./pages/authorization-error/authorization-error.component";
import {EmailVerifiedComponent} from "./pages/email-verified/email-verified.component";
import {TermsAcceptanceComponent} from "./pages/terms-acceptance/terms-acceptance.component";
import {DeviceComponent} from "./pages/device/device.component";
import {MfaChallengeComponent} from "./pages/mfa/mfa-challenge.component";
import {MfaEnrollComponent} from "./pages/mfa/mfa-enroll.component";

export const routes: Routes = [{
  // Epic 30 / Story 30.3 — authorize now redirects to /login (not root) so
  // the serve-pages Lambda can intercept and return a custom page. In
  // production, CloudFront routes GET /login → ServePagesFunction, which
  // either serves a published custom page or 302s to the SPA root. This
  // route exists for local dev parity only (in prod, serve-pages handles it).
  path: "login",
  component: LoginComponent
},{
  path: "signup",
  component: SignupComponent
},{
  path: "forgot-password",
  component: ForgotPasswordComponent
},{
  path: "reset-password",
  component: ResetPasswordComponent
},{
  path: "verify-email-error",
  component: VerifyEmailErrorComponent
},{
  // Story 50.1 — the page for the non-redirectable /authorize failures,
  // reached by identity's 302. Since 50.2 the path is a discovery/serve-pages
  // route keyed by HOST: an active custom domain serves the tenant's page,
  // everything else falls through to this SPA route. 50.3: `?reason=` says
  // which check failed.
  path: "authorization-error",
  component: AuthorizationErrorComponent
},{
  path: "email-verified",
  component: EmailVerifiedComponent
},{
  path: "terms-acceptance",
  component: TermsAcceptanceComponent
},{
  // Story 32.4 — RFC 8628 device verification/approval page. Standalone route
  // reached from the device's verification_uri (?user_code=… pre-fills the code).
  path: "device",
  component: DeviceComponent
},{
  // Story 47.2 — end-user MFA step-up interstitials (platform defaults). /authorize
  // 302s here post-password when an MFA-required application meets a session
  // that has not done MFA; the device page hops here on mfa_required. Story 47.4
  // lets operators publish custom pages over these exact URLs (serve-pages
  // falls through to these routes when none is published — the 30.3 fallback).
  path: "mfa/challenge",
  component: MfaChallengeComponent
},{
  path: "mfa/enroll",
  component: MfaEnrollComponent
},{
  path: "",
  component: LoginComponent
}];
